function debounce(func, delay) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  };
}

let lastScrollPosition = 0;

function checkScrollPosition() {
  debounce(function () {
    const navBarHeight = document?.querySelector("nav")?.offsetHeight; // Get the nav bar height
    const heroHeight = document?.querySelector(
      ".post__hero-banner-wrapper"
    )?.offsetHeight; // Get the nav bar height
    const scrollPosition = window.scrollY;

    const totalHeight = heroHeight ? heroHeight + navBarHeight : navBarHeight;

    if (
      document.body.classList.contains("overflow-hidden") ||
      document.body.classList.contains("navSearchOpen")
    ) {
      if (scrollPosition > 0) {
        document.body.classList.add("scrolled");
      }

      document.body.classList.remove("scrolled-down");
      document.body.classList.remove("scrolled-up");
    } else {
      if (scrollPosition > lastScrollPosition) {
        document.body.classList.add("scrolled-down");
        document.body.classList.remove("scrolled-up");
      } else if (scrollPosition < lastScrollPosition) {
        document.body.classList.add("scrolled-up");
        document.body.classList.remove("scrolled-down");
      }

      if (scrollPosition > 0) {
        document.body.classList.add("scrolled");
      } else {
        document.body.classList.remove("scrolled-down");
        document.body.classList.remove("scrolled-up");
        document.body.classList.remove("scrolled");
      }

      // Check if scrolled past nav bar height
      if (scrollPosition > navBarHeight) {
        document.body.classList.add("scrolledPastHeader");
      } else {
        document.body.classList.remove("scrolledPastHeader");
      }

      // Check if scrolled past hero banner
      if (heroHeight && scrollPosition > totalHeight) {
        document.body.classList.add("scrolledPastHero");
      } else {
        document.body.classList.remove("scrolledPastHero");
      }

      lastScrollPosition = scrollPosition;
    }
  }, 200)();
}

window.addEventListener("scroll", checkScrollPosition);

if (document.readyState !== "loading") {
  checkScrollPosition();
} else {
  document.addEventListener("DOMContentLoaded", checkScrollPosition);
}
